module.exports = (socket, initActionType) => {
  let id;
  let token;

  return () => {
    return next => action => {
      if (action.type === initActionType) {
        id = action.payload.id;
        token = action.payload.token;
      }

      if (
        socket &&
        action.meta &&
        action.meta.analytics &&
        action.meta.analytics.channel
      ) {
        if (id && token) {
          const { channel } = action.meta.analytics;
          socket.emit(channel, { id, token, payload: action.payload });
        }
      }

      next(action);
    };
  };
};



// WEBPACK FOOTER //
// ../shared/optilit-redux-middleware/socket-analytics-emit.js